export const attorneyTitle = "Member Management";
export const clientDetails = "Member Details";
export const editClient = "Edit Member";
export const attorneyTitleButton = "Add New Member";
export const attorneyAddClientTitle = "Add Member Information"
export const cliManagement = "Member Management";
export const bankinformation = "Bank Information"
export const addClient = "Add Member";
export const searchPlaceholder = "Search by Name, Email & Mobile Phone";
export const documentDetails="Document Details";
export const editClientTitle = "Edit Member Information";
export const viewPeople = "Details";
export const executorDetails="Executor Details";
export const addFamily = "Add Emergency contact";
export const attorneyAddFamilyTitle = "Add Emergency contact Information";
export const attorneyEditFamilyTitle = "Edit Emergency contact Information";
export const shareDownloadMessage = "Your file will download automatically. Please check your Downloads folder";
export const citynationalbank = "city national bank"

export const attorneyDetails = {
    fullName: "Member Name",
    email: "Email",
    phone: "Mobile Phone",
    uploadedDocuments: "Uploaded Documents",
    willsUploaded: "Wills Uploaded",
    cliActions: "Actions",
    nextBtn: "Next",
    cancelBtn: "Cancel",
    submitBtm: "Submit"
}

export const clientPlaceholder = {
    firstName: "First Name",
    lastName: "Last Name",
    email: "Email",
    phone: "Mobile Phone",
    dob: "DOB",
    addressLine1: "Address Line 1",
    addressLine2: "Address Line 2",
    zip: "Zip",
    cityList: "City",
    city: "City",
    state: "State",
    country: "Country",
    submitBtnText: "Submit",
    relationship:"Relationship",
    driversLicense:"Driver’s License / Passport",
    mothersMaidenName:"Mother’s Maiden Name",
    recipient_addressline1: "Recipient Address Line 1",
    recipient_addressLine2: "Recipient Address Line 2",
    recipient_city: "Recipient City",
    recipient_state: "Recipient State",
    recipient_country: "Recipient Country",
    recipient_zip: "Recipient Zip",
    beneficiary_addressLine1: "Bank Address Line 1",
    beneficiary_addressLine2: "Bank Address Line 2",
    beneficiary_city: "Bank City",
    beneficiary_state: "Bank State",
    beneficiary_country: "Bank Country",
    beneficiary_zip: "Bank Zip",
  };
  export const addPeopleTitle= [
    //"Add Family Information",
    "Add Executor Information",
    "Add Sucessor Information",
    "Add Witness Information",
    "Add Co-Executor Information"
] 